import { LinearProgress } from "@mui/material";

const LoadingTakeover = () => {
    return (
        <div className='full-overlay'>
            <LinearProgress />
        </div>
    )
};

export default LoadingTakeover;